module.exports = require("babel-runtime/helpers/typeof");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/typeof"
// module id = 10
// module chunks = 0